<template>
  <generic-config 
    :values="getCounterparties"
    displayText="name"
    :onSaveHandler="onSave"
    :onDeleteHandler="onDelete"
    entityName="Counterparty"
    >
    <template v-slot:entryForm="{selectedItem, onSaveItem, onDeleteItem}">
      <EntryForm 
        :model="dataModel"
        :data="selectedItem"
        :mode="selectedItem ? 'viewEdit' : 'new'"
        @onSave="onSaveItem"
        @onDelete="onDeleteItem"
      />
    </template>
    <template v-slot:itemListing="{onItemSelected, values, displayText}">
      <item-list 
        title="" 
        :items="values" 
        :text="displayText" 
        :clickable="true" 
        @onClick="onItemSelected"/>
    </template>
  </generic-config>
</template>

<script>
import GenericConfig from "@/components/common/GenericConfig";
import EntryForm from "@/components/common/EntryForm";
import ItemList from '@/components/common/ItemList.vue';

import { Counterparty } from '@/model';

export default {
  components: {
    GenericConfig,
    EntryForm,
    ItemList
  },
  async created() {
    await this.$store.dispatch("getCounterparties");
  },
  data: () => ({
    dataModel : [
        {label: 'Uuid', valueAttr: 'uuid', type: 'text', display: false},
        {label: 'Name', valueAttr: 'name', type: 'text', display: true, required: true},
      ]
  }),
  computed: {
    counterparties() {
      return Counterparty.sort(this.$store.state.counterparties)
        .map(cp => ({ uuid: cp.uuid, name: cp.name}));
    }
  },
  methods: {
    getCounterparties(cp) {
      if (!cp || !cp.uuid) {
        return this.counterparties;
      }
      return this.counterparties.filter(c => c.uuid !== cp.uuid);
    },
    async onSave(valueObject) {
      const counterparty = Counterparty.fromJson(valueObject);
      await this.$store.dispatch("saveCounterparty", counterparty);
    },
    async onDelete([valueObject, replacement]) {
      const counterparty = Counterparty.fromJson(valueObject);
      const replacementCp = replacement ? Counterparty.fromJson(replacement) : undefined;
      await this.$store.dispatch("deleteCounterparty", [counterparty, replacementCp]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>